const FORM_ID_SESSION_KEY_PREFIX = 'selectedFormId';
const FORM_ID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const sanitizeFormId = (value: string | null | undefined): string | undefined => {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  if (!FORM_ID_PATTERN.test(trimmed)) return undefined;
  return trimmed.toLowerCase();
};

const getTenantKey = (tenant?: string | null) => (tenant || 'default').trim().toLowerCase();

export const getSelectedFormIdStorageKey = (tenant?: string | null): string =>
  `${FORM_ID_SESSION_KEY_PREFIX}:${getTenantKey(tenant)}`;

export const setSelectedFormIdInSession = (
  tenant: string | null | undefined,
  formId: string | null | undefined,
): void => {
  if (typeof window === 'undefined') return;
  const formIdKey = getSelectedFormIdStorageKey(tenant);
  const sanitized = sanitizeFormId(formId);
  if (!sanitized) {
    window.sessionStorage.removeItem(formIdKey);
    return;
  }
  window.sessionStorage.setItem(formIdKey, sanitized);
};

export const getSelectedFormIdFromSession = (tenant?: string | null): string | undefined => {
  if (typeof window === 'undefined') return undefined;
  const key = getSelectedFormIdStorageKey(tenant);
  const stored = window.sessionStorage.getItem(key);
  const sanitized = sanitizeFormId(stored);
  if (!sanitized && stored) {
    window.sessionStorage.removeItem(key);
  }
  return sanitized;
};

export const parseSelectedFormIdFromSearch = (
  search?: string,
): {
  hasFormIdParam: boolean;
  selectedFormIdFromUrl?: string;
  cleanedSearch: string;
} => {
  const params = new URLSearchParams(search || '');
  const hasFormIdParam = params.has('formId') || params.has('form_id');
  const raw = params.get('formId') || params.get('form_id');
  params.delete('formId');
  params.delete('form_id');
  return {
    hasFormIdParam,
    selectedFormIdFromUrl: sanitizeFormId(raw),
    cleanedSearch: params.toString(),
  };
};

export const resolveSelectedFormId = (
  tenant: string | null | undefined,
  search?: string,
): string | undefined => {
  const { hasFormIdParam, selectedFormIdFromUrl } = parseSelectedFormIdFromSearch(search);
  if (hasFormIdParam) {
    return selectedFormIdFromUrl;
  }
  return getSelectedFormIdFromSession(tenant);
};
